// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3eAfR","choiceBoxes":"toolbarselects_choiceBoxes__Uh68S","simpleField":"toolbarselects_simpleField__ej8GE"};